import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Custom methods
import { isArray, findLast } from "../../Libs/CustomMethods/customMethods";

import { defaultMsg } from "../../components/OperatorArea/functions/chat";

// Messages Redux States
import {
  GET_CONSUMER_CONVERSATIONS,
  GET_CONSUMER_MESSAGES,
  GET_MESSAGES,
  GET_MESSAGE,
  START_OBSERVER,
  SEND_MESSAGE,
  CLOSE_CHAT,
  TABULATE_CHAT,
  TABULATE_CHAT_TICKET,
  DISABLE_CHAT,
  SEND_INACTIVITY_MSG,
  UPLOAD_FILE,
  JOIN_CONVERSATION,
  GET_TABS_CHAT,
  GET_SKILLS_ATTENDANCE,
  CREATE_ATTENDANCE,
  CREATE_COMMENTARY,
  DELETE_COMMENTARY,
} from "./actionTypes";
import {
  apiError,
  setMessages,
  startedObserver,
  sentMessage,
  uploadedFile,
  closedChat,
  setTabsChat,
  tabulatedChat,
  disabledChat,
  setConsumerConversations,
  setConsumerMessages,
  getConsumerError,
  agentInactivitated,
  joinedConversation,
  setSkillsAttendance,
  createdAttendance,
  createCommentarySuccess,
  createCommentaryFailure,
  deleteCommentarySuccess,
  deleteCommentaryFailure,
} from "./actions";

import { reopenConversationRes } from "../reopenConversation/actions";

//Include Both Helper File with needed methods
import axios from "axios";
import { getInteractions } from "../interactions/actions";

// TODO: move these conditional message expressions to a common file
const isClientMsg = (m) => m?.by === "consumer" ?? false;
const isAgentMsg = (m) => m?.by === "agent" ?? false;
const isAllowedUserMsg = (m) => isAgentMsg(m) || isClientMsg(m);
const isPrivateMsg = (m) => m?.private ?? false;
const isValidMsg = (m) => !isPrivateMsg(m) && isAllowedUserMsg(m);

const getFirstWithoutAnswer = (e) => {
  // Array of messages from Agent or Client
  let pubMsgs = e?.message?.filter((msg) => isValidMsg(msg));

  // Last message of array
  let lastPubMsg = pubMsgs[pubMsgs.length - 1];

  // Find index of firstWithoutAnswer
  let idxFWA = -1;

  if (isAgentMsg(lastPubMsg)) {
    // Last message is from Agent then find last of Client
    idxFWA = pubMsgs.indexOf(findLast(pubMsgs, isClientMsg)) + 1; // Sum 1 to get first Agent message after last Client message;
  } else if (isClientMsg(lastPubMsg)) {
    // Last message is from Client then find last of Agent
    idxFWA = pubMsgs.indexOf(findLast(pubMsgs, isAgentMsg)) + 1; // Sum 1 to get first Client message after last Agent message
  }

  return pubMsgs[idxFWA] ?? defaultMsg(e); // defaultMsg is to prevent the practically impossible case of a conversation that has no messages from either client or agent
};

const getResponseData = (arrayData) => {
  let reponseData = [];
  const pullAt = new Date();
  if (isArray(arrayData)) {
    reponseData = arrayData.map((e) => {
      if (e.status !== "closed" && e.status !== "pos-chat") {
        let firstWithoutAnswer = getFirstWithoutAnswer(e);

        let time = firstWithoutAnswer?.sentTime;

        // If conversation is assigned
        if (e?.assignedTime) {
          if (
            new Date(firstWithoutAnswer?.sentTime).getTime() <=
            new Date(e?.assignedTime).getTime()
          ) {
            time = e?.assignedTime;
          }
        } else if (e?.createdAt) {
          time = e?.createdAt;
        }

        return {
          ...e,
          firstWithoutAnswer: {
            by: firstWithoutAnswer?.by,
            time,
          },
          events: {
            disableChat: {
              limitAttempts: 3,
              countAttempts: 0,
            },
            agentInactivity: {
              limitAttempts: 3,
              countAttempts: 0,
            },
          },
          prevScrollTop: null,
          pullAt,
        };
      } else {
        return { ...e, prevScrollTop: null, pullAt };
      }
    });
  }
  return reponseData;
};

function* getMessages({ payload: { id, interval } }) {
  try {
    let aux = id ? { byManager: true } : "";

    const response = yield call(
      axios.get,
      `${process.env.REACT_APP_MESSAGES_API_URL}/tech4h-messages/conversation?${
        (id ? "&id=" + id + "&byManager=true" : "") +
        (interval ? "&interval=" + interval : "")
      }`,
      aux
    );

    if (response.status === 200) {
      let responseData = { ...response.data };
      let auxData = getResponseData(response?.data?.data);
      responseData.data = auxData;
      yield put(setMessages(responseData));
      yield put(
        reopenConversationRes(
          { data: auxData, loading: false, success: "api" },
          "api"
        )
      );
    } else {
      throw response.data;
    }
  } catch (error) {
    let message = "Get chats error";

    yield put(apiError({ action: "get_messages", message: message }));
  }
}

function* startObserver({ payload: { id } }) {
  try {
    const response = yield call(
      axios.get,
      `${
        process.env.REACT_APP_MESSAGES_API_URL
      }/tech4h-messages/conversation/observer/start${
        id ? "?id=" + id + "&conversationData=true" : ""
      }`
    );

    if (response.status === 200) {
      let responseData = { ...response.data };
      let auxData = getResponseData(response?.data?.data);
      responseData.data = auxData;
      yield put(startedObserver(responseData));
      yield put(
        reopenConversationRes(
          { data: auxData, loading: false, success: "api" },
          "api"
        )
      );
    } else {
      throw response.data;
    }
  } catch (error) {
    let message = "Get chats error";

    yield put(apiError({ action: "get_messages", message: message }));
  }
}
function* getMessage({ payload: { conn, idMessage } }) {
  try {
  } catch (error) {
    yield put(apiError(error));
  }
}
function* sendMessage({ payload: { data, isPrivate } }) {
  try {
    let aux = {
      ...data.message,
      date: data?.date?.getTime(),
    };

    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_MESSAGES_API_URL}/channel/response/send/${
        data.chatId
      }/${isPrivate ? "private" : ""}`,
      aux
    );

    if (response.status === 200) {
      // msgs status: sending, sent, delivered, read
      yield put(
        sentMessage({
          message: response?.data?.data?.message,
          chatId: data?.chatId,
          previousId: response?.data?.data?.previousId,
          currentId: response?.data?.data?.currentId,
          sendTime: data?.date,
          sentTime: data?.date,
          files: response?.data?.data?.files,
          status: {
            sending: false,
            sent: true,
            delivered: null,
            read: null,
            error: null,
          },
        })
      );
    } else {
      throw response.data;
    }
  } catch (error) {
    let message = "SEND: default error";
    if (error.response && error.response.status) {
      if (error.response.data && error.response.data.message)
        message = error.response.data.message;
      else message = error.message;
    }
    yield put(apiError({ action: "send_message", message: message }));
  }
}
function* uploadFile({ payload: data }) {
  try {
    let sendTime = data?.sendTime.getTime();

    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_MESSAGES_API_URL}/channel/upload/file/${data.chatId}/${sendTime}/`,
      data?.formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    if (response.status === 200) {
      yield put(
        uploadedFile({
          sendTime: data?.sendTime,
          fileId: response?.data?.data?.fileId,
        })
      );
    } else {
      throw response.data;
    }
  } catch (error) {
    let message = "SEND FILE: error";
    if (error?.response?.status) {
      if (error?.response?.data?.message) {
        message = error.response.data.message;
      } else {
        message = error?.message;
      }
    }
    yield put(apiError({ action: "upload_file", message: message }));
  }
}

function* agentInactivitate({ payload: data }) {
  try {
    let aux = {
      ...data?.message,
      date: Math.floor(Date.now() / 1000),
    };
    let params = {};

    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_MESSAGES_API_URL}/channel/response/send/${data.chatId}`,
      aux,
      {
        headers: { Authorization: `${data.token}` },
        params,
      }
    );

    if (response.status === 200) {
      // msgs status: sending, sent, delivered, read
      yield put(
        agentInactivitated({
          msgId: data.sendTime,
          sentTime: new Date(aux.date * 1000),
          chatId: data.chatId,
          status: {
            sending: false,
            sent: true,
            delivered: null,
            read: null,
            error: null,
          },
        })
      );
    } else {
      throw response.data;
    }
  } catch (error) {
    let message = "SEND: default error";
    if (error.response && error.response.status) {
      if (error.response.data && error.response.data.message)
        message = error.response.data.message;
      else message = error.message;
    }
    yield put(apiError({ action: "agent_inactivity", message: message }));
  }
}

function* getConsumerConversations({ payload: { id, typeChannel } }) {
  try {
    const response = yield call(
      axios.get,
      `${process.env.REACT_APP_MESSAGES_API_URL}/tech4h-messages/consumer/${id}/conversations/${typeChannel}`
    );

    if (response.status === 200) {
      yield put(setConsumerConversations(id, response.data));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message = "Get consumer msgs error";
    yield put(
      getConsumerError({ action: "get_conversations", message: message })
    );
  }
}
function* getConsumerMessages({ payload: { id, page, qnt } }) {
  try {
    const response = yield call(
      axios.get,
      `${process.env.REACT_APP_MESSAGES_API_URL}/tech4h-messages/message` +
        `?${
          (id ? `conversationId=${id}` : "") +
          (page ? `&page=${page}` : "") +
          (qnt ? `&qtd=${qnt}` : "")
        }`
    );

    if (response.status === 200) {
      yield put(setConsumerMessages(id, response.data));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message = "Get consumer msgs error";
    yield put(getConsumerError({ action: "get_messages", message: message }));
  }
}
// TODO: use the same method to call change status
// function* changeStatus(data, callback, action) {}

function* closeChat({ payload: { id, data } }) {
  try {
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_MESSAGES_API_URL}/tech4h-messages/conversation/change-status?id=${id}`,
      data
    );

    if (response.status === 200) {
      const status = response?.data?.data?.hasPosChat
        ? "pos-chat"
        : data.status;
      yield put(
        closedChat({
          chatId: id,
          status,
          tabId: data.tabId,
        })
      );
    } else {
      throw response.data;
    }
  } catch (error) {
    let message = "CHANGE: default error";
    if (error.response && error.response.status) {
      if (error.response.data && error.response.data.message)
        message = error.response.data.message;
      else message = error.message;
    }
    yield put(apiError({ action: "close_chat", message: message }));
  }
}
function* getTabsChat({
  payload: { chatId, conversations, isInformationTab },
}) {
  try {
    const response = yield call(
      axios.get,
      `${process.env.REACT_APP_MESSAGES_API_URL}/tech4h-messages/conversation/tab/${chatId}`,
      {
        params: {
          conversations: conversations.length > 0 ? conversations : undefined,
          isInformationTab,
        },
      }
    );
    if (response.status === 200 && response?.data?.data) {
      yield put(setTabsChat(response.data.data));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message = "Get tabs error";
    if (error.response && error.response.status) {
      if (error.response.data && error.response.data.message)
        message = error.response.data.message;
      else message = error.message;
    }
    yield put(apiError({ action: "get_tabs_skill", message: message }));
  }
}

function* tabulateChat({ payload: { id, data } }) {
  try {
    const response = yield call(
      axios.put,
      `${process.env.REACT_APP_MESSAGES_API_URL}/tech4h-messages/conversation/tab/${id}`,
      { tab_id: data.tabId }
    );

    if (response.status === 200) {
      yield put(
        tabulatedChat({
          chatId: id,
          tabId: data.tabId,
          message: response?.data?.message,
        })
      );
    } else {
      throw response.data;
    }
  } catch (error) {
    let message = "CHANGE: default error";
    if (error.response && error.response.status) {
      if (error.response.data && error.response.data.message)
        message = error.response.data.message;
      else message = error.message;
    }
    yield put(apiError({ action: "tabulate_chat", message: message }));
  }
}

function* tabulateChatTicket({ payload: { id, data } }) {
  try {
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_MESSAGES_API_URL}/tech4h-messages/response/send/realautomation/${id}`,
      data
    );

    if (response.status === 200) {
      yield put(
        tabulatedChat({
          chatId: id,
          tabId: data.tabId,
          files: data?.files ?? null,
          message: response?.data?.message,
          type: "real_automation",
          infoTab: data?.infoTab,
        })
      );

      yield put(getInteractions(id));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message = "CHANGE: default error";
    if (error.response && error.response.status) {
      if (error.response.data && error.response.data.message)
        message = error.response.data.message;
      else message = error.message;
    }
    yield put(apiError({ action: "tabulate_chat", message: message }));
  }
}

function* disableChat({ payload: data }) {
  try {
    let aux = {
      status: data?.status,
    };
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_MESSAGES_API_URL}/tech4h-messages/conversation/change-status?id=${data?.chatId}`,
      aux,
      {}
    );
    if (response.status === 200 || response.status === 400) {
      yield put(
        disabledChat({
          chatId: data?.chatId,
          status: data?.status,
        })
      );
    } else {
      throw response.data;
    }
  } catch (error) {
    let message = "disable chat error";
    if (error?.response?.status) {
      message = error.response.data?.message ?? error?.message;
    }
    yield put(apiError({ action: "disable_chat", message: message }));
  }
}

function* joinConversation({ payload: id }) {
  try {
    const response = yield call(
      axios.get,
      `${
        process.env.REACT_APP_MESSAGES_API_URL
      }/tech4h-messages/conversation/manager/join${id ? "?id=" + id : ""}`
    );

    if (response.status === 200) {
      yield put(joinedConversation());
    } else {
      throw response.data;
    }
  } catch (error) {
    let message = "Join conversation error";

    yield put(apiError({ action: "join_conversation", message: message }));
  }
}

function* getSkillsAttendance() {
  try {
    const response = yield call(axios.get, `/skillBySource?source=telefone`);

    if (response.status === 200) {
      yield put(setSkillsAttendance(response.data.data));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message = "Get skills attendance error";
    if (error.response && error.response.status) {
      if (error.response.data && error.response.data.message)
        message = error.response.data.message;
      else message = error.message;
    }
    yield put(setSkillsAttendance(null, message));
  }
}

function* createAttendance({ payload: { data } }) {
  try {
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_MESSAGES_API_URL}/channel/phone/receive/${data?.skill}`,
      data
    );

    if (response.status >= 200 && response.status < 300) {
      yield put(createdAttendance(response.data.data));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message = "Get skills attendance error";
    if (error.response && error.response.status) {
      if (error.response.data && error.response.data.message)
        message = error.response.data.message;
      else message = error.message;
    }
    yield put(createdAttendance(null, message));
  }
}

function* createCommentary({ payload: { id, message, isPublic } }) {
  try {
    const response = yield call(
      axios.post,
      `${process.env.REACT_APP_MESSAGES_API_URL}/tech4h-messages/conversations/${id}/comments`,
      {
        content: message,
        isPublic,
      }
    );

    if (response.status >= 200 && response.status < 300) {
      yield put(createCommentarySuccess());
      yield put(getInteractions(id));
    } else {
      throw response.data;
    }
  } catch (error) {
    console.log(error);
    let message = "Get skills attendance error";
    if (error.response && error.response.status) {
      if (error.response.data && error.response.data.message)
        message = error.response.data.message;
      else message = error.message;
    }
    yield put(createCommentaryFailure(message));
  }
}

function* deleteCommentary({ payload: { id, conversationId } }) {
  try {
    const response = yield call(
      axios.delete,
      `${process.env.REACT_APP_MESSAGES_API_URL}/tech4h-messages/conversations/${conversationId}/comments/${id}`
    );

    if (response.status >= 200 && response.status < 300) {
      yield put(deleteCommentarySuccess());
      yield put(getInteractions(conversationId));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message = "Cannot delete commentary.";
    if (error.response && error.response.status) {
      if (error.response.data && error.response.data.message)
        message = error.response.data.message;
      else message = error.message;
    }
    yield put(deleteCommentaryFailure(message));
  }
}

export function* watchGetMessages() {
  yield takeEvery(GET_MESSAGES, getMessages);
}
export function* watchStartObserver() {
  yield takeEvery(START_OBSERVER, startObserver);
}
export function* watchGetMessage() {
  yield takeEvery(GET_MESSAGE, getMessage);
}
export function* watchSendMessage() {
  yield takeEvery(SEND_MESSAGE, sendMessage);
}
export function* watchUploadFile() {
  yield takeEvery(UPLOAD_FILE, uploadFile);
}
export function* watchCloseChat() {
  yield takeEvery(CLOSE_CHAT, closeChat);
}
export function* watchTabsSkillChat() {
  yield takeEvery(GET_TABS_CHAT, getTabsChat);
}
export function* watchTabulateChat() {
  yield takeEvery(TABULATE_CHAT, tabulateChat);
}
export function* watchTabulateChatTicket() {
  yield takeEvery(TABULATE_CHAT_TICKET, tabulateChatTicket);
}
export function* watchDisableChat() {
  yield takeEvery(DISABLE_CHAT, disableChat);
}
export function* watchGetConsumerConversations() {
  yield takeEvery(GET_CONSUMER_CONVERSATIONS, getConsumerConversations);
}
export function* watchGetConsumerMessages() {
  yield takeEvery(GET_CONSUMER_MESSAGES, getConsumerMessages);
}
export function* watchAgentInactivitate() {
  yield takeEvery(SEND_INACTIVITY_MSG, agentInactivitate);
}
export function* watchJoinConversation() {
  yield takeEvery(JOIN_CONVERSATION, joinConversation);
}
export function* watchGetSkillsAttendance() {
  yield takeEvery(GET_SKILLS_ATTENDANCE, getSkillsAttendance);
}
export function* watchCreateAttendance() {
  yield takeEvery(CREATE_ATTENDANCE, createAttendance);
}
export function* watchCreateCommentary() {
  yield takeEvery(CREATE_COMMENTARY, createCommentary);
}
export function* watchDeleteCommentary() {
  yield takeEvery(DELETE_COMMENTARY, deleteCommentary);
}
function* authSaga() {
  yield all([
    fork(watchGetMessages),
    fork(watchStartObserver),
    fork(watchGetMessage),
    fork(watchSendMessage),
    fork(watchUploadFile),
    fork(watchCloseChat),
    fork(watchTabulateChat),
    fork(watchTabulateChatTicket),
    fork(watchTabsSkillChat),
    fork(watchDisableChat),
    fork(watchGetConsumerConversations),
    fork(watchGetConsumerMessages),
    fork(watchAgentInactivitate),
    fork(watchJoinConversation),
    fork(watchGetSkillsAttendance),
    fork(watchCreateAttendance),
    fork(watchCreateCommentary),
    fork(watchDeleteCommentary),
  ]);
}

export default authSaga;
